//@flow
import React from 'react';
import s from './SubSectionList.less';
import {numberToFixed} from '../../../../helpers';

type Props = {
  totalFOB: number,
  sectionSummary: Array<Object>,
  percentFOB: string,
  sectionCost: number,
};

const SubSectionList = (props: Props) => {
  return (
    <div className={`${s.subSectionListWrapper}`}>
      {props.sectionSummary.map ((summaryDetail, index) => {
        const notHundredPercent = summaryDetail.percentOfTotal !== '100.0%';
        return (
          <div
            className={`${s.noMargin} ${s.listItem} ${summaryDetail.detail.includes ('Total') ? s.bold : ''}  ${notHundredPercent && summaryDetail.detail === 'Total' ? s.notHundredPercent : ''}`}
            key={summaryDetail.detail}
          >
              {props.title === 'Material Cost' && (summaryDetail.detail === "Flyknit" || summaryDetail.detail === "NonFlyknit" ) ?
                  <div style={{width:'130px',paddingLeft:'40px'}}>
                      {summaryDetail.detail}
                  </div>
              :
            <div style={{width:'120px'}}>
             {summaryDetail.detail}
            </div>}
              {props.title === 'Labor Cost'&& (
                    <div className={`${s.listItemValue}`}>
                      <span className={`${s.right}`} style={{width:'35px',whiteSpace:'nowrap',overflow:'hidden', textOverflow:'ellipsis'}} title={summaryDetail.std}>
                    {summaryDetail.std}
                      </span>
                    </div>
              )}
              {props.title === 'Labor Cost'&& (
                  <div className={`${s.listItemValue}`}>
                    <span className={`${s.right}`} style={{width:'35px',whiteSpace:'nowrap',overflow:'hidden', textOverflow:'ellipsis'}} title={summaryDetail.obsv}>
                  {summaryDetail.obsv}
                    </span>
                  </div>
                  )}
              {props.title === 'Material Cost' && (summaryDetail.detail === "Flyknit" || summaryDetail.detail === "NonFlyknit" ) ?
                  <div style={{width:'130px',paddingRight:'150px'}} className={`${s.listItemValue}`}>
                  <span>
              {`$${numberToFixed (summaryDetail.cost, 2)}`}
                  </span>
                  <span style={{paddingRight:'100px'}}className={`${s.percentFob}`}>
                  ({summaryDetail.percentOfTotal})
                  </span>
                  </div>
                  :
            <div className={`${s.listItemValue}`}>
              <span style={{width:'40px',whiteSpace:'nowrap',overflow:'hidden', textOverflow:'ellipsis'}} title={`$${numberToFixed (summaryDetail.cost, 2)}`}>
                {`$${numberToFixed (summaryDetail.cost, 2)}`}
              </span>
              <span className={`${s.percentFob}`}>
                ({summaryDetail.percentOfTotal})
              </span>
            </div>}
          </div>
        );
      })}
    </div>
  );
};

export default SubSectionList;



// WEBPACK FOOTER //
// ./src/components/SummarySubSections/SummarySubSection/SubSectionList/SubSectionList.js